"use client"

import { createContext, type RefObject } from "react"

export type ReportDialogOpenContextValue = {
  reportDialogOpen: boolean
  setReportDialogOpen: (open: boolean) => void
  portalTargetRef: RefObject<HTMLDivElement | null> | null
} | null

export const ReportDialogOpenContext = createContext<ReportDialogOpenContextValue>(null)
